"use client";

import { useRouter, useParams } from "next/navigation";
import { TriviaRoutes } from "../components/trivia/routes";

export const useRedirect = () => {
  const router = useRouter();
  const { slug } = useParams<{ slug: string }>();

  const redirect = (route: TriviaRoutes | string) => {
    const url = route.replace("{slug}", slug as string);
    router.push(url);
  };

  return { redirect };
};
